export const sparkedModeSelector = ({sparkedMode}) => sparkedMode